export default "__VITE_ASSET__CH4TVp3K__"